export default {
  appVersionGetDownloadApp: '/v1/appVersion/getDownloadApp' // 下载APP链接接口
}
